export const hoursInDay = 24;
export const minutesInHour = 60;
export const secondsInMinute = 60;
export const millisecondsInSecond = 1000;

export const dayInMilliSeconds =
  hoursInDay * minutesInHour * secondsInMinute * millisecondsInSecond;
